import React from 'react';
import FormMessage from '../../FormMessage';

const ToBePaidOutEmpty = () => (
  <div className="no-bets">
    <FormMessage className="no-bets__message" />
    <section className="no-bets__section">
      <h2 className="no-bets__heading">No recent activity</h2>
      <p className="no-bets__paragraph">
        Your uncollected cashed in and winning bets will appear here when they become available.
      </p>
    </section>
  </div>
);

export default ToBePaidOutEmpty;
